import {
  BrowserModule,
  BrowserTransferStateModule,
} from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app.routing";
import { HttpClientModule } from "@angular/common/http";
import { LoaderService } from "./loader/LoaderService";
import { AsyncPipe } from "@angular/common";
import { MenuComponent } from "./league-module/menu/menu.component";
import { SocialModule } from "./social-module/social.module";
import { StoredDataModel } from "./app.models";
import { CommonService } from "./services/common.service";
import { DeviceDetectorModule } from "ngx-device-detector";
import { ExperimentComponent } from "./experiment/experiment.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AuthGuard } from "./auth.guard";
import { Broadcaster } from "./app.broadcaster";
import { TeamPreviewModule } from "./shared/component/team-preview/team-preview.module";

@NgModule({
  declarations: [AppComponent, MenuComponent, ExperimentComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    SocialModule,
    HttpClientModule,
    DeviceDetectorModule.forRoot(),
    BrowserTransferStateModule,
    TeamPreviewModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
  ],
  providers: [
    CommonService,
    Broadcaster,
    LoaderService,
    AsyncPipe,
    StoredDataModel,
    AuthGuard,
  ],
  // providers: [LoaderService],
  bootstrap: [AppComponent],
})
export class AppModule {}
